import React from 'react';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import navbarsStyle from 'assets/jss/material-kit-react/views/componentsSections/navbarsStyle.jsx';
import {
    TextField,
    Button,
    Grid,
    FormControl,
    Select,
    MenuItem
} from '@material-ui/core';
import { withRouter } from 'react-router-dom';
import * as actions from '../../actions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import Autocomplete from 'react-google-autocomplete';

class HomeSearchBar extends React.Component {
    constructor(props) {
        super();
        this.state = {
            providerData: [],
            redirect: false,
            loaderButton: false,
            city: props.city ? props.city : '',
            category: props.category ? props.category : 0,
            featured: props.featured ? props.featured : false
        };
    }
    handleSearchClick = () => {
        this.getData();
    };
    getData = () => {
        const { city, category, featured } = this.state;

        this.setState({ loaderButton: true });
        this.props.providerSearchListAction(
            {
                type: 0,
                featured: featured,
                category,
                city,
                page: 1
            },
            this.onDone
        );
    };

    onAllDone = (success, data) => {
        if (success) {
            this.props.receivedData(
                data.data,
                this.state.city,
                this.state.category,
                this.state.serviceId,
                data.previous,
                data.next
            );
            this.setState({
                providerData: data.data,
                loader: false,
                redirect: true,
                loaderButton: false
            });
        } else {
            this.setState({
                providerData: [],
                loader: false,
                redirect: true,
                loaderButton: false
            });
        }
    };

    onDone = (success, data) => {
        if (success) {
            this.props.receivedData(
                data.data,
                this.state.city,
                this.state.category,
                this.state.serviceId,
                data.previous,
                data.next
            );
            this.setState({
                providerData: data.data,
                loader: false,
                redirect: true,
                loaderButton: false
            });
        } else {
            this.props.receivedData(
                [],
                this.state.city,
                this.state.category,
                this.state.serviceId,
                true,
                true
            );
            this.setState({
                providerData: [],
                loader: false,
                redirect: true,
                loaderButton: false
            });
        }
    };

    getSelectedService = service => {
        if (typeof service != 'undefined') {
            this.setState({ keyword: service.heading, serviceId: service.key });
        }
    };

    handleCategoryChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
            loaderButton: false
        });
    };

    keywordChange = event =>
        this.setState({
            keyword: event.target.value,
            loaderButton: false
        });

    render() {
        const { classes } = this.props;
        const { type, loaderButton } = this.state;
        const { formatMessage } = this.props.intl;

        return (
            <div className={classes.container + ' ' + 'search-container'}>
                <Grid container className="search-container-row">
                    <Grid
                        item
                        lg={4}
                        md={4}
                        sm={12}
                        xs={12}
                        className="search-container-col"
                    >
                        <Autocomplete
                            name={'city'}
                            placeholder={'Search City'}
                            style={{
                                width: '100%'
                            }}
                            onChange={() => this.setState({ city: '' })}
                            defaultValue={this.state.city}
                            className="search-container-select search-container-input2"
                            onPlaceSelected={place => {
                                this.setState({
                                    city: place.address_components[0].long_name
                                });
                            }}
                            types={['(regions)']}
                            componentRestrictions={{ country: 'sa' }}
                        />
                    </Grid>
                    <Grid
                        item
                        lg={4}
                        md={4}
                        sm={12}
                        xs={12}
                        className="search-container-col"
                    >
                        <FormControl
                            className="search-container-select"
                            style={{ minWidth: 300, marginTop: 20, margin: 0 }}
                        >
                            <Select
                                className="searhvar-filter"
                                name="category"
                                value={this.state.category}
                                onChange={this.handleCategoryChange}
                                inputProps={{
                                    name: 'category',
                                    id: 'type-simple',
                                    margin: 'normal',
                                    defaultValue: this.state.category
                                }}
                            >
                                <MenuItem selected={true} value={0}>
                                    <em>
                                        <FormattedMessage
                                            id="selectCategory"
                                            defaultMessage="Select Category"
                                        />
                                    </em>
                                </MenuItem>
                                {!this.props.categories.categoryLoader &&
                                    this.props.categories.categoryData.map(
                                        (category, index) => {
                                            return (
                                                <MenuItem
                                                    key={index}
                                                    value={category.key}
                                                >
                                                    <em>{category.heading}</em>
                                                </MenuItem>
                                            );
                                        }
                                    )}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item lg={4} md={4} sm={12} xs={12}>
                        {!loaderButton ? (
                            <Button
                                variant="contained"
                                size="large"
                                color="primary"
                                style={{
                                    color: '#ffffff',
                                    width: '100%',
                                    padding: '15px',
                                    marginTop: '11px'
                                }}
                                onClick={this.handleSearchClick}
                            >
                                <FormattedMessage
                                    id="Search"
                                    defaultMessage="Search"
                                />
                            </Button>
                        ) : (
                            <Button
                                variant="contained"
                                size="large"
                                color="primary"
                                style={{
                                    color: '#ffffff',
                                    width: '100%',
                                    padding: '15px',
                                    marginTop: '11px'
                                }}
                                disabled={true}
                            >
                                <FormattedMessage
                                    id="homesearch.searching"
                                    defaultMessage="Searching..."
                                />
                            </Button>
                        )}
                    </Grid>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = ({ categories }) => {
    return { categories };
};

const composedComponent = compose(
    withStyles(navbarsStyle),

    connect(
        mapStateToProps,
        actions
    )
);

export default composedComponent(withRouter(injectIntl(HomeSearchBar)));



// WEBPACK FOOTER //
// ./src/components/SearchBar/HomeSearchBar.js